"use client"

import Kicker from "components/Kicker"
import SplitTextAnimation from "components/SplitText"
import gsap, { ScrollTrigger, SplitText } from "gsap/all"
import { css, f, styled } from "library/styled"
import colors from "styles/colors"
import textStyles from "styles/text"

gsap.registerPlugin(SplitText, ScrollTrigger)

export default function SyntheticCaptive() {
	return (
		<Wrapper>
			<Inner>
				<StyledKicker doubleIcon size="large">
					Arlo’s Synthetic Captive
				</StyledKicker>
				<Title end="bottom 50%">
					We use the combined power of your small group block to offer better
					pricing, smoothened renewals, and access to top vendors - without the
					high fees and legal hassle typical of traditional captives.
				</Title>
			</Inner>
		</Wrapper>
	)
}

const Wrapper = styled("section", {
	...f.responsive(css`
		position: relative;
		display: grid;
		place-items: center;
		width: 100%;
	`),
})

const Inner = styled("div", {
	...f.responsive(css`
		width: 1440px;
		padding: 234px 0;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		align-items: center;
	`),
	...f.tablet(css`
		width: 1024px;
		padding: 316px 0;
	`),
	...f.mobile(css`
		width: 375px;
		padding: 152px 0;
	`),
})

const StyledKicker = styled(Kicker, {
	...f.responsive(css`
		margin-bottom: 32px;
	`),
	...f.mobile(css`
		margin-bottom: 36px;
	`),
})

const Title = styled(SplitTextAnimation, {
	...f.responsive(css`
		${textStyles.h5};
		color: ${colors.js.green100};
		text-align: center;
		width: 1074px;
		margin: 0 auto;
		display: block;
	`),
	...f.tablet(css`
		width: 720px;
	`),
	...f.mobile(css`
		${textStyles.bodyXL};
		width: 327px;
	`),
})
